export const IDE_TYPE = {
  TEXT_JAM: 1,
  BLOCK_JAM: 2,
};
